var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-drawer',{attrs:{"title":_vm.scope.subject,"visible":_vm.isShowMore,"direction":"rtl","size":"50%"},on:{"update:visible":function($event){_vm.isShowMore=$event},"close":_vm.close}},[_c('div',{staticStyle:{"margin-left":"60px","font-size":"14px"},domProps:{"innerHTML":_vm._s(_vm.scope.context)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }